// extracted by mini-css-extract-plugin
module.exports = {"row":"Row_row__lAlXD","number":"Row_number__7xr7_","status":"Row_status__3C8Fv","col":"Row_col__IW6h_","box":"Row_box__1WKgT","label":"Row_label__20AYl"};